"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestUser = void 0;
var fetchable_1 = require("./fetchable");
var object_1 = require("./objects/object");
var rest_1 = require("./rest");
var rest_department_1 = require("./rest.department");
var IkeRestUser = /** @class */ (function () {
    function IkeRestUser(core, accessToken) {
        var _this = this;
        this.Objects = object_1.IkeRestObjects;
        this.User = {
            Settings: {
                change: this.bindAction('user.settings.set')
            },
            me: this.bindAction('user.me'),
            ipfDatabases: this.bindAction('user.ipf.databases')
        };
        this.Version = {
            check: this.bindAction('version.check')
        };
        this.Department = {
            acceptInvite: this.bindAction('department.invite.accept'),
            list: this.bindAction('department.list'),
            adminList: this.bindAction('department.admin.list'),
            writeableList: this.bindAction('department.writeable.list')
        };
        this.Org = {
            getById: this.bindAction('org.get.orgid')
        };
        this.Device = {
            getByDeviceId: this.bindAction('device.get.deviceid')
        };
        this.Event = {
            batch: this.bindAction('event.batch'),
            extract: this.bindAction('event.extract'),
            process: this.bindAction('event.process')
        };
        this.core = core;
        this.log = core.log.child({ accessToken: accessToken });
        this.accessToken = accessToken;
        this.me = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), function () { return _this.User.me(); });
        this.departments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return _this.Department.list().then(function (c) { return c.results; }); });
        this.adminDepartments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return _this.Department.adminList().then(function (c) { return c.results; }); });
        this.writeableDepartments = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return _this.Department.writeableList().then(function (c) { return c.results; }); });
    }
    IkeRestUser.prototype.bind = function (departmentId) {
        if (this.boundDepartmentId !== departmentId) {
            this.boundDepartmentId = departmentId;
            this.boundDepartmentRest = new rest_department_1.IkeRestDepartment(this, departmentId);
        }
        return this.boundDepartmentRest;
    };
    IkeRestUser.prototype.action = function (action, data) {
        return this.core._post(action, data, this.accessToken, null);
    };
    IkeRestUser.prototype.bindAction = function (action) {
        var _this = this;
        return function (data) { return _this.action(action, data); };
    };
    return IkeRestUser;
}());
exports.IkeRestUser = IkeRestUser;
//# sourceMappingURL=rest.user.js.map